import React, { useId } from 'react';

import { token } from '@atlaskit/tokens';

export const CardCoverArtwork = (): React.JSX.Element => {
	const id = useId();
	const gridId = `${id}-grid`;

	return (
		<svg width="100%" height="100%" aria-hidden="true" focusable="false">
			<defs>
				<pattern id={gridId} width="32" height="32" patternUnits="userSpaceOnUse" x="23" y="23">
					<path
						d="M 1 1 H 33 M 1 1 V 33"
						fill="none"
						stroke={token('color.border.bold')}
						strokeOpacity={0.5}
						strokeWidth={1.25}
						strokeDasharray="0 4"
						strokeLinecap="round"
					/>
				</pattern>
			</defs>
			<rect width="100%" height="100%" fill={`url(#${gridId})`} />
		</svg>
	);
};
